import React from "react";

import HappyTeamsLogo from "../../images/happyTeamsTool.png";
import BiocentricHealthTheory from "../../images/biocentric_health_theory.png";

import classes from "./Footer.module.css";

const Footer = () => {
  return (
    <footer className={classes.footer}>
      <a href="https://app.happyteams.de" target="_blank" rel="noreferrer"><img src={HappyTeamsLogo} alt="HappyTeams tool link" /></a>
      <img className={classes.image_biocentric} src={BiocentricHealthTheory} alt="Biocentric Health Theory logo" />
    </footer>
  );
}

export default Footer;